import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CNContactType } from 'src/app/models/cncontacttype';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-contact-types-group-list',
  templateUrl: './contact-types-group-list.component.html',
  styleUrls: ['./contact-types-group-list.component.scss']
})
export class ContactTypesGroupListComponent implements OnInit {

  public types: CNContactType[];
  @Output() selected: EventEmitter<CNContactType> = new EventEmitter();

  constructor(private contactSvr: ContactService) { }

  ngOnInit(): void {
    this.contactSvr.types.subscribe(types => {
      this.types = types;
    });
  }

  selectType(type: CNContactType): void {
    this.selected.emit(type);
  }
}
